// extracted by mini-css-extract-plugin
export default {"inputColor":"style_inputColor__Jfj8u"};